import React, {
  useReducer,
  createContext,
  useMemo,
  useCallback,
} from "react";
import { useRefStore, useRefDataStore } from "../../..";
import { killConfiguracion, deleteData } from "./PantallaReducer";

export const initialState = {
  modales: [], // ejemplo : [{ id_a: "UN_MODAL", open: false, data: {}, zIndex }],
  zIndex: 1030,
};

export const ModalesContext = createContext();
export default ModalesContext;

export const ModalProvider = (props) => {
  const [state, dispatch] = useReducer(ModalReducer, initialState);

  const [configuraciones, setRefState] = useRefStore((s) => s.configuraciones);
  const [refDataState, , removeFromDataState] = useRefDataStore();

  const abrirModal = (id_a, data) => {
    dispatch({ type: "OPEN_MODAL", payload: { id_a, data } });
  };

  const cerrarModal = useCallback(
    (id_a) => {
      // El modal debe desmontarse por completo. AdemÃ¡s de quitar su
      // configuraciÃ³n, se eliminan los valores que sus campos dejaron en el
      // store compartido para que una nueva apertura no reutilice datos viejos.
      const newDataState = deleteData(id_a, { configuraciones }, refDataState);
      removeFromDataState(newDataState);
      setRefState({
        configuraciones: killConfiguracion(id_a, { configuraciones }),
      });
      dispatch({ type: "CLOSE_MODAL", payload: { id_a } });
    },
    [configuraciones, refDataState, removeFromDataState, setRefState]
  );

  const addModal = useCallback(
    ({ id_a, data, parametro_id, propsModal, qsBody }) => {
      dispatch({
        type: "ADD_MODAL",
        payload: {
          id_a,
          open: true,
          data,
          parametro_id,
          zIndex: state.modales.length * 10 + state.zIndex,
          cerrar: () => cerrarModal(id_a, data),
          propsModal,
          props: propsModal,
          qsBody,
        },
      });
    },
    [cerrarModal, state.modales.length, state.zIndex]
  );

  const getModal = useCallback(
    (id_a) => {
      const modal = state.modales.find((m) => m.id_a === id_a);

      if (!modal) return {};
      return modal;
    },
    [state.modales]
  );

  const cerrar = useCallback(
    (id_a) => {
      const m = getModal(id_a);
      if (typeof m.cerrar === "function") {
        return m.cerrar();
      }

      // Puede ocurrir que quien abrió el modal conserve una referencia de un
      // render anterior. El cierre directo evita dejar un modal huérfano.
      return cerrarModal(id_a);
    },
    [cerrarModal, getModal]
  );

  // useEffect(() => {
  //   setRefState(props.refState.configuraciones);
  // }, [props.refState, setRefState]);

  return (
    <ModalesContext.Provider
      value={useMemo(() => {
        return {
          state,
          modales: state.modales,
          zIndex: state.zIndex,
          abrirModal,
          cerrarModal: cerrar,
          addModal,
          getModal,
          dispatch,
        };
      }, [addModal, cerrar, getModal, state])}
    >
      {props.children}
    </ModalesContext.Provider>
  );
};

export const ModalReducer = (state, action) => {
  switch (action.type) {
    case "ADD_MODAL": {
      // Un id_a identifica una Ãºnica instancia. Reemplazar una eventual
      // instancia anterior garantiza que el contenido se vuelva a montar.
      const modales = state.modales.filter(
        (modal) => modal.id_a !== action.payload.id_a,
      );
      return {
        ...state,
        modales: [...modales, action.payload],
      };
    }

    case "OPEN_MODAL": {
      const modales = state.modales.map((modal) =>
        modal.id_a === action.payload.id_a
          ? { ...modal, open: true, data: action.payload.data }
          : modal,
      );
      return {
        ...state,
        modales,
        zIndex: state.zIndex + state.modales.length,
      };
    }

    case "CLOSE_MODAL":
      return {
        ...state,
        modales: state.modales.filter(
          (modal) => modal.id_a !== action.payload.id_a,
        ),
      };

    default:
      return state;
  }
};
